module.exports = __webpack_public_path__ + "img/circle_alert_two.b2a28594.svg";